export default __webpack_public_path__ + "static/media/TravelBackpack1.50f288ca.jpg";